import type { TourConfig } from '../../types/tour.types'

// GDPR / data restrictions. Anchors are `data-tour` attributes on the view (added alongside
// this tour). Walks the user from the map, through adding a restriction, to saving the result.
const gdprTour: TourConfig = {
  id: 'gdpr',
  title: 'Stay compliant with data restrictions',
  module: 'Settings',
  routeName: 'Gdpr',
  order: 20,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Control where you can prospect',
      body: 'Set the **countries and regions** where contact data should be restricted, so exports and outreach respect **GDPR and local data-protection laws** automatically — keeping your organisation compliant.',
    },
    {
      id: 'map',
      target: '[data-tour="gdpr-map"]',
      placement: 'bottom',
      title: 'See and set restrictions on the map',
      body: 'Restricted countries show in **red**. **Click any country** on the map to add a restriction in one step — a fast way to see your compliance posture at a glance.',
    },
    {
      id: 'add',
      target: '[data-tour="gdpr-add"]',
      placement: 'bottom',
      title: 'Add by region or country',
      body: 'Prefer search? Pick a whole **region** (like the EU) or a single **country** here. Regions restrict every country inside them at once.',
    },
    {
      id: 'table',
      target: '[data-tour="gdpr-table"]',
      placement: 'top',
      title: 'Fine-tune each restriction',
      body: 'Every active restriction is listed here. Toggle **email** and **mobile** independently, check the local **legislation**, or **remove** a restriction you no longer need.',
    },
    {
      id: 'save',
      target: '[data-tour="gdpr-save"]',
      placement: 'top',
      title: 'Save to apply everywhere',
      body: 'Your changes only take effect once you **Save**. After saving, restricted data is masked across search, exports and CRM — consistently, everywhere.',
    },
  ],
}

export default gdprTour
